export const PLAN_FEE_AMOUNT = 100
export const PLAN_FEE_PERCENT = 1

export const PLAN_FEATURES = [
  'Support services',
  'Full account setup',
  'Costs for Ad servers',
  '1,000 Ad scores (with 3rd parties)'
]
